define('bizzabo/views/UploadFileCloudinaryView',[
    'backbone',
    'underscore',
    'easyXDM',
    'bizzabo/consts',
    'bizzabo/config',
    'https://widget.cloudinary.com/global/all.js',
    'hbars!bizzabo/templates/uploadFileCloudinary'
], function(
    Backbone,
    _,
    easyXDM,
    Consts,
    CONFIG,
    GlobalCloudinary,
    template
    ) {

    var UploadFileCloudinaryView = Backbone.View.extend({

        events: {
            'click .customUploadButton': 'uploadImage',
            'click .uploadFileWrapper': 'uploadImage'
        },

        initialize: function(options) {
            _.bindAll(this, 'uploadImage');
            options = options || {};
            this.cloudinary = window.cloudinary;
            this.smallButton = options.smallButton;
            this.recommendedSize = options.recommendedSize || 'Recommended size: 400W X 400H. Must be JPG, GIF, or PNG.';
            this.cloudinaryOptions = _.defaults((options || {}), {
                cloud_name: CONFIG.CLOUDINARY_CLOUD_NAME,
                upload_preset: CONFIG.CLOUDINARY_UPLOAD_PRESET,
                multiple: false,
                max_image_width: 750,
                max_image_height: 1024,
                show_powered_by: false,
                theme: 'minimal',
                resource_type: 'image'
            });
        },

        uploadImage: function() {
            var thisView = this;
            this.cloudinary && this.cloudinary.openUploadWidget(thisView.cloudinaryOptions,
                function(error, result) {
                    if (error) {
                        this.$('p.error').html(error.message);
                        return;
                    }
                    var imageURL = result[0].secure_url;
                    var arr = imageURL.split('upload');
                    var croppedImageUrl = arr[0] + 'upload/c_crop,g_custom' + arr[1];
                    thisView.image = croppedImageUrl;
                    thisView.trigger('success');
                    Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                        category: 'Organizer Responses',
                        action: 'File uploaded'
                    });
                });
        },

        render: function() {
            var html = template({
                smallButton: this.smallButton,
                recommendedSize: this.recommendedSize
            });
            this.$el.html(html);

            return this;
        }

    });

    return UploadFileCloudinaryView;

});
